import React from "react";

interface ProtectedComponentProps {
  children: React.ReactNode;
  roleKey?: string;
  allowedModules?: string[];
  requiredModule?: string;
}

const ProtectedComponent: React.FC<ProtectedComponentProps> = ({
  children,
  roleKey,
  allowedModules,
  requiredModule,
}) => {
  if (
    roleKey === "super-admin" ||
    allowedModules?.includes(requiredModule ?? "")
  ) {
    return <>{children}</>;
  }
  return null;
};

export default ProtectedComponent;
